class Offer {
  constructor({ id, name, desc, conditions, coupons, pin }) {
    this.id = id;
    this.name = name;
    this.desc = desc;
    this.conditions = conditions;
    this.coupons = coupons;
    this.authorizePIN = null; //User input PIN
    this.pin = pin; //Current PIN of offer
  }

  clone() {
    return new Offer({
      id: this.id,
      name: this.name,
      desc: this.desc,
      conditions: this.conditions,
      pin: this.pin,
      coupons: this.coupons.map((coupon) => coupon.clone()),
    });
  }

  set pin(PIN) {
    if (PIN) this.authorizePIN = String(PIN);
    else this.authorizePIN = "";
  }

  get pin() {
    return this.authorizePIN;
  }

  getTotalDiscount(totalPrice) {
    const discount = this.coupons.reduce((total, coupon) => {
      return total + coupon.getDiscountNumber(totalPrice);
    }, 0);
    return discount;
  }

  isPassCondition(qty, totalPrice, totalNoDiscount) {
    return this.conditions.every((condition) =>
      condition.isPassCondition(qty, totalPrice, totalNoDiscount)
    );
  }

  /**
   * Display in Cart Panel
   * @returns
   */
  getOfferMessageInCart(locale) {
    if (!this.coupons) {
      return "";
    }
    if (this.coupons.length <= 0) {
      return "";
    }
    return this.coupons[0].getMessage(locale);
  }

  getPayloadData(pricebeforeDiscount, lan) {
    if (this.authorizePIN === "") {
      //Donot send authorization_pin
      return {
        offer_id: this.id,
        item_ref: "OFFER001",
        item_type: "offer",
        event_code: "EARN",
        target: "instant",
        coupons: this.coupons.map((coupon) =>
          coupon.getPayloadData(pricebeforeDiscount, lan)
        ),
      };
    } else
      return {
        offer_id: this.id,
        item_ref: "OFFER001",
        item_type: "offer",
        event_code: "EARN",
        target: "instant",
        pin: this.pin,
        authorize_pin: this.authorizePIN === "" ? null : this.authorizePIN,
        coupons: this.coupons.map((coupon) =>
          coupon.getPayloadData(pricebeforeDiscount, lan)
        ),
      };
  }
}

export default Offer;
